// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"3a2bd3f4c9ff6379f300","883":"4e7ed79b7ce1691f4ab8"}[chunkId] + ".js";
};